<template>
    <div :style="'border-top: inset 150px transparent; box-sizing: border-box;background: url(' + require('@/assets/image/globes.png') + ') top '+(isEN ?'right' : 'left')+' no-repeat'">
        <div :class="[isEN ? 'ltr-fa' : '','position-relative']">
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew response bg-gradient">
                </div>
                <div class="container shape-container d-flex" style="padding-top: 10rem !important;">
                    <div :class="[isEN ? 'style-ltr' : 'style-ltr', 'col px-0']">
                        <div class="row">
                            <div class="col-lg-8" :style="isEN ? '' : 'margin-left: auto; text-align:right'">
                                <h1 :class="[isEN ? '' : '', 'text-dark', 'display-1', 'multi-line']">{{intro_pr}}</h1>
                                <h1 :class="[isEN ? '' : '', 'text-dark', 'display-1', 'multi-line']">{{intro_sc}}</h1>
                                <p :class="[isEN ? '' : '', 'lead' , 'text-dark', 'multi-line']">{{intro}}</p>
                                <div class="btn-wrapper">
                                    <base-button tag="span"
                                                 @click="$router.push('/form')"
                                                 class="mb-3 mb-sm-0"
                                                 type="default"
                                                 :style="isEN ? '' : 'margin-left: 0.5rem !important; margin-right: unset !important;' "
                                                 :icon="isEN ? 'ni ni-curved-next' : 'fa fa-chevron-left'">
                                        {{language.lang("Get Started")}}
                                    </base-button>
                                    <!--                                    <base-button tag="span"-->
                                    <!--                                                 @click="$router.push(oracle.isLoggedIn() ? '/profile' : '/login')"-->
                                    <!--                                                 :style="isEN ? 'margin-left: 0.5rem !important; margin-right: unset !important;' : '' "-->
                                    <!--                                                 class="mb-3 mb-sm-0"-->
                                    <!--                                                 type="white"-->
                                    <!--                                                 icon="ni ni-circle-08">-->
                                    <!--                                        {{language.lang(oracle.isLoggedIn() ? 'My Dashboard' : 'Already a member?')}}-->
                                    <!--                                    </base-button>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <section class="section section-lg pt-lg-0" style="margin-top: -300px">
            <div class="container mt-5" v-if="offers.length > 0">
                <div class="d-flex flex-wrap">
                    <div v-for="(item, index) in offers" :key="index" class="col-3" style="position: relative">
                        <img style="width: 80px; height: 80px; border-radius: 100%;position: absolute; left: calc(50% - 40px); top: -35px; z-index: 10000"
                             :src="item.offer_icon"
                             class="center-cropped">
                        <card no-body shadow :style="'background-image: url('+item.offer_avatar+ ')'"
                              style="height: 400px;"
                              class="center-cropped ml-2 mr-2 text-center">
                            <div style="width: 100%; height: 100%; position: relative" class="d-flex flex-column">
                                <span class="mr-3 ml-3 text-center"
                                      style="margin-top: 35px;font-size: 18px; color: white; z-index: 100;">
                                    {{item.offer_title}}
                                </span>
                                <div style="height: 1px; background-color: #f4f5f7; opacity: 0.5;"
                                     class="ml-3 mr-3 mt-1 mb-3"></div>
                                <span class="font-weight-bold mr-3 ml-3 mt-auto mb-auto text-center"
                                      style="margin-top: 35px;font-size: 20px; color: white; z-index: 100;">
                                    {{item.offer_brief}}
                                </span>
                                <span class="mr-3 ml-3 text-center mt-auto mb-auto"
                                      style="margin-top: 35px;font-size: 14px; color: white; z-index: 100;">
                                    {{item.offer_description}}
                                </span>
                                <div class="mt-auto" style="width: 100%; height: 25px; background-color: white;"></div>
                                <div role="button" v-ripple class="d-flex flex-row shadow" @click="item.offer_link.toString().startsWith('http') ? oracle.newTab(item.offer_link) : $router.push(item.offer_link)"
                                     style="z-index: 100; border-radius: 50px; padding: 10px 20px; background-color: #427BD5; width: fit-content; position: absolute; left: calc(50% - 60px); bottom: 55px; z-index: 120">
                                    <i :class="isEN ? 'mr-2' : 'ml-2'" class="fa fa-check-circle" style="color: white; align-self: center"></i>
                                    <span style="font-size: 13px; color: white; align-self: center"
                                          class="font-weight-bold">{{language.lang('Get Started!')}}</span>
                                </div>
                                <div role="button" @click="item.offer_url.toString().startsWith('http') ? oracle.newTab(item.offer_url) : $router.push(item.offer_url)"
                                     v-ripple class="d-flex flex-row" style="background-color: white; height: 50px; width: 100%; align-items: center">
                                    <span :class="isEN ? 'ml-auto' : 'mr-auto'" style="font-size: 14px; color: black;align-self: center">{{language.lang('How it works')}}</span>
                                    <i style="font-size: 14px; color: black;align-self: center"
                                     :class="isEN ? ' mr-auto ml-2 fa-chevron-right' : ' ml-auto mr-2 fa-chevron-left'"  class="fa "></i>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-lg-0">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div :class="[isEN ? 'style-just' : '', 'row' , 'row-grid']">
                            <div class="col-lg-4" style="min-height: 100%">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon style="color: #fff; background-color: #FFDC4A"
                                          name="fa fa-hand-paper-o" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 style="color: #525f7f;" class=" text-uppercase">
                                        {{language.lang('Quick assessment tool')}}</h6>
                                    <p style="text-align: justify;" class="description mt-3">
                                        {{language.lang('Use our free online assessment tool to check your eligibility and find the program that matches your profile in less than 1 minute.')}}
                                    </p>
                                    <div>
                                        <!--                                        <badge type="success" rounded>College</badge>-->
                                        <!--                                        <badge type="success" rounded>High school</badge>-->
                                        <!--                                        <badge type="success" rounded>Master</badge>-->
                                    </div>
                                    <base-button style="color: white; border-color:#FFDC4A; background-color: #FFDC4A"
                                                 tag="span" @click="$router.push({name: 'form', params: {id: null}})"
                                                 type="primary" class="mt-4">
                                        {{language.lang('Learn more')}}
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4" style="min-height: 100%">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon style="color: #fff; background-color: #427BD5"
                                          name="fa fa-legal" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 style="color: #525f7f;" class="text-uppercase">
                                        {{language.lang('Easy access from any where in the world')}}</h6>
                                    <p style="text-align: justify;" class="description mt-3">{{language.lang(`Access consultants who are regulated and licensed by the government of Canada to help you with your Canadian immigration application.`)}}</p>
                                    <div>
                                        <!--                                        <badge type="warning" rounded>marketing</badge>-->
                                        <!--                                        <badge type="warning" rounded>product</badge>-->
                                        <!--                                        <badge type="warning" rounded>launch</badge>-->
                                    </div>
                                    <base-button style="color: white; border-color:#427BD5; background-color: #427BD5"
                                                 tag="span" @click="$router.push({name: 'teams', params: {id: null}})"
                                                 type="success" class="mt-4">
                                        {{language.lang('Learn more')}}
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4" style="min-height: 100%">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon style="color: #fff; background-color: #F6617E"
                                          name="fa fa-hourglass-end" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 style="color: #525f7f;" class="text-uppercase">
                                        {{language.lang('Save time and money')}}</h6>
                                    <p style="text-align: justify;" class="description mt-3">{{language.lang(`Your time and hard earned money is more valuable. Here, at Visternet you can see all consultants profiles and their expertise in just one click.`)}}</p>
                                    <div>
                                        <!--                                        <badge type="warning" rounded>marketing</badge>-->
                                        <!--                                        <badge type="warning" rounded>product</badge>-->
                                        <!--                                        <badge type="warning" rounded>launch</badge>-->
                                    </div>
                                    <base-button style="color: white; border-color:#F6617E; background-color: #F6617E"
                                                 tag="span" @click="$router.push({name: 'about', params: {id: null}})"
                                                 type="warning" class="mt-4">
                                        {{language.lang('Learn more')}}
                                    </base-button>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="mb-3">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div :class="[isEN ? 'style-just' : '', 'col-md-6' , 'order-md-1']">
                        <div class="pr-md-5">
                            <icon name="ni ni-check-bold" class="mb-5" size="lg" type="success" shadow
                                  rounded></icon>
                            <h4>{{language.lang('How it works?'.toUpperCase())}}</h4>
                            <p>{{language.lang(`Follow the below steps to get connected with regulated consultants.`)}}</p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge :style="isEN ?
                                         'margin-left: 1rem !important; margin-right:  1rem !important;' : '' "
                                               type="success" circle class="mr-3 ml-3"
                                               icon="ni ni-settings-gear-65"></badge>
                                        <h6 class="mb-0">
                                            {{language.lang(`Check your eligibility using our free tool`)}}</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge :style="isEN ?
                                         'margin-left: 1rem !important; margin-right:  1rem !important;' : '' "
                                               type="success" circle class="mr-3 ml-3" icon="ni ni-html5"></badge>
                                        <h6 class="mb-0">
                                            {{language.lang(`Find a regulated immigration consultant`)}}</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge :style="isEN ?
                                         'margin-left: 1rem !important; margin-right:  1rem !important;' : '' "
                                               type="success" circle class="mr-3 ml-3" icon="ni ni-satisfied"></badge>
                                        <h6 class="mb-0">
                                            {{language.lang('Get their advice and prepare your Visa application')}}
                                        </h6>
                                    </div>
                                </li>
                                <!--                                <li class="py-2">-->
                                <!--                                    <div class="d-flex align-items-center">-->
                                <!--                                        <badge :style="isEN ?-->
                                <!--                                         'margin-left: 1rem !important; margin-right:  1rem !important;' : '' "-->
                                <!--                                               type="success" circle class="mr-3 ml-3" icon="ni ni-satisfied"></badge>-->
                                <!--                                        <h6 class="mb-0">{{language.lang('Get ready to travel to Canada')}}</h6>-->
                                <!--                                    </div>-->
                                <!--                                </li>-->
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 order-md-2 ">
                        <img :src="require('@/assets/image/services.jpg')" class="img-fluid floating">
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div style="background-color: #427BD5" class="card shadow border-0">
                            <img :src="require('@/assets/image/detail.jpg')" class="card-img-top">
                            <blockquote :class="[!isEN ? 'style-rtl' : '','card-blockquote']">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2"
                                             class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">
                                    {{language.lang('Did you know?'.toUpperCase())}}</h4>
                                <!--                                <p :class="[isEN ? 'style-just' : '','lead','text-italic','text-white']">-->
                                <!--                                    {{language.lang(loremSample)}}</p>-->
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div :class="[!isEN ? 'style-rtl style-just' : '','pl-md-5']">
                            <icon name="fa fa-diamond" class="mb-5" size="lg" type="warning" shadow rounded></icon>
                            <h3>{{language.lang('Did you know?'.toUpperCase())}}</h3>
                            <p style="text-align: justify;">{{language.lang(`Only representatives authorized and licensed by the government of Canada are allowed to evaluate your Visa application and submit it on your behalf. If you choose a paid representative who’s not authorized by the government of Canada, they may return your application or refuse it.`)}}</p>
                            <span role="button" @click="$router.push('/about')" class="font-weight-bold text-warning mt-5">
                                {{language.lang(`Learn more about us`)}}
                                <i :class="[!isEN ? 'fa fa-chevron-left ml-1' : 'fa fa-chevron-right ml-1']"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div :class="[!isEN ? 'style-rtl style-just' :'', 'col-lg-6','order-lg-1' ]">
                        <div class="d-flex px-3">
                            <div class="pr-md-5">
                                <icon name="fa fa-hand-peace-o" class="mb-5" size="lg" type="success" shadow
                                      rounded></icon>
                                <h3>{{language.lang('What Our Users Experienced'.toUpperCase())}}</h3>
                                <p style="text-align: justify;">{{language.lang(`Whether you’re a person looking for the right immigration pathway to Canada or an Agency in the need of an experienced consultant, we are here to support you.`)}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <carousel :dots="true" :autoplay="true" :autoWidth="true" :autoHeight="true" :center="true"
                          :nav="false">
                    <div v-for="(item, index) in allRate" :key="index" :class="[!isEN ? 'style-ltr' :'']">
                        <card style="width: 400px" shadow class="shadow-lg--hover mt-5 mb-5 ml-2 mr-2">
                            <div :class="'flex-column ' + (isEN ? 'text-left' : 'text-right')">
                                <icon name="ni ni-satisfied" gradient="success" color="white" shadow rounded></icon>
                                <h5 class="title text-success mt-3">{{item.name}}</h5>
                                <p>{{item.text}}</p>
                                <v-rating class="m-0 p-0" :style="(!isEN ? 'margin-left' : 'margin-right') + ': -10px !important;'" length="5"
                                          :value="5" readonly></v-rating>
                            </div>
                        </card>
                    </div>
                </carousel>
            </div>
        </section>
        <!--        <section>-->
        <!--            <div class="container">-->
        <!--                <div class="d-flex px-3">-->
        <!--                    <div class="pr-md-5">-->
        <!--                        <icon name="ni ni-ungroup" class="mb-5" size="lg" type="success" shadow-->
        <!--                              rounded></icon>-->
        <!--                        <h3>{{language.lang('OUR AMAZING TEAM'.toUpperCase())}}</h3>-->
        <!--                        <p class="col-5 p-0">{{language.lang(loremSample)}}</p>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <carousel :nav="false" :autoplay="true" v-if="lawyers.length > 0">-->
        <!--                    <div class="px-4" v-for="(item, index) in lawyers" v-bind:key="index"-->
        <!--                       role="button"  @click="$router.push({name: 'lawyer', params: {id: item.lawyer_id}})">-->
        <!--                        <img :src="item.lawyer_cover != null ? item.lawyer_cover :
                                 require('@/assets/image/user_avatar.png')"-->
        <!--                             class="rounded-circle img-center img-fluid shadow shadow-lg&#45;&#45;hover center_cropped"-->
        <!--                             style="width: 150px; height: 150px">-->
        <!--                        <div class="pt-4 text-center">-->
        <!--                            <h5 class="title title-text">-->
        <!--                                <span style="font-size: 15px" class="d-block font-weight-bold mb-1">{{item.lawyer_title}}</span>-->
        <!--                                <small class="h6 text-muted">{{item.lawyer_brief}}</small>-->
        <!--                            </h5>-->
        <!--                            <div v-if="item.lawyer_contact_public != null"-->
        <!--                                 class="row mt-3 mb-3 mr-auto ml-auto text-default">-->
        <!--                                <div class="ml-auto"></div>-->
        <!--                                <i @click="oracle.newTab(item.lawyer_contact_public.facebook)"-->
        <!--                                   v-if="!oracle.isEmpty(item.lawyer_contact_public.facebook)"-->
        <!--                                   style="width: 25px; height: 25px; font-size: 20px"-->
        <!--                                   class="m-1 fa fa-facebook badge-circle"></i>-->
        <!--                                <i @click="oracle.newTab(item.lawyer_contact_public.twitter)"-->
        <!--                                   v-if="!oracle.isEmpty(item.lawyer_contact_public.twitter)"-->
        <!--                                   style="width: 25px; height: 25px; font-size: 20px"-->
        <!--                                   class="m-1 fa fa-twitter badge-circle"></i>-->
        <!--                                <i @click="oracle.newTab(item.lawyer_contact_public.instagram)"-->
        <!--                                   v-if="!oracle.isEmpty(item.lawyer_contact_public.instagram)"-->
        <!--                                   style="width: 25px; height: 25px; font-size: 20px"-->
        <!--                                   class="m-1 fa fa-instagram badge-circle "></i>-->
        <!--                                <i @click="oracle.newTab(item.lawyer_contact_public.youtube)"-->
        <!--                                   v-if="!oracle.isEmpty(item.lawyer_contact_public.youtube)"-->
        <!--                                   style="width: 25px; height: 25px; font-size: 20px"-->
        <!--                                   class="m-1 fa fa-youtube badge-circle "></i>-->
        <!--                                <div class="mr-auto"></div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </carousel>-->
        <!--            </div>-->
        <!--        </section>-->
        <section class="section-shaped my-0 overflow-hidden">
            <div style="background-color: #427BD5" class="shape shape-style-3 shape-skew">
            </div>
            <div class="container pt-lg pb-300">
                <div class="row row-grid align-items-center">
                    <div :class="[!isEN ? 'style-rtl style-just' :'', 'col-lg-6','order-lg-1' ]">
                        <div class="d-flex">
                            <div class="">
                                <icon class="mb-5" name="fa fa-info" size="lg" color="primary" gradient="white"
                                      shadow
                                      rounded></icon>
                                <h3 class="text-white">{{language.lang('Partner with us today!'.toUpperCase())}}</h3>
                                <!--                                <p class="text-white">{{language.lang(loremSample)}}</p>-->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="ni ni-settings" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">{{language.lang('1. Send a request')}}</h5>
                        <p style="" class="text-white mt-3">{{language.lang(`Send us your request via email at partnership@visternet.com.`)}}</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-ruler-pencil" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">{{language.lang('2. Get connected to our team')}}</h5>
                        <p style="" class="text-white mt-3">
                            {{language.lang('A designated personal will get back to you within 48 hours.')}}</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-atom" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">{{language.lang(`3. Let's get successful`)}}</h5>
                        <p style="" class="text-white mt-3">{{language.lang(`Let’s create a better experience for people and grow.`)}}</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import language from '@/utils/language'
    import carousel from 'vue-owl-carousel'
    import oracle from "@/utils/oracle";

    export default {
        name: "home",
        components: {carousel},
        data() {
            return {
                offers: [],
                rating: 5,
                lawyers: [],
                allRate: [
                    {
                        name: 'Mona Kian',
                        text: 'Happy to find this easy to use and comprehensive platform'
                    }
                    , {
                        name: 'Abhi Varma',
                        text: 'When I used it to choose my consultant, it was so easy and straight forward, all in one place. I appreciate their great customer service.'
                    },
                    {
                        name: 'Mona Kian',
                        text: 'Happy to find this easy to use and comprehensive platform'
                    }, {
                        name: 'Abhi Varma',
                        text: 'When I used it to choose my consultant, it was so easy and straight forward, all in one place. I appreciate their great customer service.'
                    }, {
                        name: 'Abhi Varma',
                        text: 'When I used it to choose my consultant, it was so easy and straight forward, all in one place. I appreciate their great customer service.'
                    },
                ],
                slide: 0,
                commentSection: null,
                intro: "",
                intro_pr: "",
                intro_sc: "",
                oracle: oracle,
                language: language,
                isEN: oracle.isEN(),
            }
        },
        methods: {},
        mounted() {
            oracle.axios('setting/getInfo', {
                "filter_by": this.oracle.isEN() ? 'website_en' : 'website',
                "search_by": 'intro'
            }, (response) => {
                this.intro = response.data
            })
            oracle.axios('setting/getInfo', {
                "filter_by": this.oracle.isEN() ? 'website_en' : 'website',
                "search_by": 'intro_pr'
            }, (response) => {
                this.intro_pr = response.data
            })
            oracle.axios('setting/getInfo', {
                "filter_by": this.oracle.isEN() ? 'website_en' : 'website',
                "search_by": 'intro_sc'
            }, (response) => {
                this.intro_sc = response.data
            })
            oracle.axios('lawyer/getRawList', {
                "limit_by": 1000,
            }, (response) => {
                this.lawyers = response.data
            })
            oracle.axios('offer/getList', {
                "limit_by": 1000, "order_by": 'priority',
            }, (response) => {
                this.offers = response.data
            })
        }
    };
</script>

<style>
    .style-rtl {
        direction: rtl !important;
        text-align: right;
    }

    .style-ltr {
        direction: ltr !important;
        text-align: left;
    }

    .style-just {
        text-align: justify;
    }

    .transform {
        transform: rotate(180deg) !important;
    }

    .response {
        object-position: center !important;
        background-size: cover !important;
    }

    .style-marg {
        margin-left: 10px;
    }

    .title-text {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .border-0 {
        min-height: inherit;
    }

    @media only screen and (max-width: 900px) {
        .section-shaped .shape.shape-skew + .shape-container {
            padding-bottom: unset !important;
        }

        .row.row-grid > [class*="col-"] + [class*="col-"] {
            margin-top: unset !important;
        }

        .mt-5, .my-5 {
            margin-top: unset !important;
        }

        .section-shaped .shape {
            height: 115% !important;
        }
    }

</style>